export const colors = {
  primary: '#20639B',
  secondary: '#3CAEA3',
  tertiary: '#911803',

  light: '#f4f4f4',
  medium: '#d9d9d9',
  darker: '#bfbfbf',
  dark: '#848484',

  enabled: '#3caea3',
  disabled: '#9fb2b0',
};
